<template>
  <a class="detail-icon" :href="href()"
    onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">
    <svg><use xlink:href="#facebook"></use></svg>
  </a>
</template>

<style scoped>
</style>

<script>
export default {
    props: {
        facebookAppId: {
            type: String,
            default: window.jrConfig.facebookAppId,
        },
        url: {
            type: String,
            default: ''
        },
        imageUrl: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
    },

    methods: {
        href: function () {
            return 'https://www.facebook.com/dialog/share?app_id=' + this.facebookAppId +
                    '&display=popup&href=' + encodeURIComponent(this.url) +
                    '&quote=' + encodeURIComponent(this.description)
        }
    },
}
</script>
